module.exports = __webpack_public_path__ + "static/img/frontPage.2854417f.jpg";